// App.tsx
import { useEffect } from 'react';

import './App.css'
import Routes from './routes/router';
import { fetchAdminUserDetails, logout as storeLogout } from './store/slices/authSlice';
import { useAppDispatch } from './store/hooks';

const App = () => {
  const dispatch = useAppDispatch();
  //const user = useAppSelector((state) => state.auth.user);
  

  // Token refresh
  useEffect(() => {
    const handleTokenRefresh = () => {
      dispatch(fetchAdminUserDetails());
    };
    const handleTokenRefreshFailed = () => {
      dispatch(storeLogout());
    };

    window.addEventListener('tokenRefreshed', handleTokenRefresh);
    window.addEventListener('tokenRefreshFailed', handleTokenRefreshFailed);

    return () => {
      window.removeEventListener('tokenRefreshed', handleTokenRefresh);
      window.removeEventListener('tokenRefreshFailed', handleTokenRefreshFailed);
    };
  }, [dispatch]);

  return <Routes />;
};

export default App;